export const TRIGGER_TYPES = {
  BINARY: 'BINARY',
}

export const TRIGGER_CATEGORIES = {
  MATCH: 'MATCH',
  TEAM: 'TEAM',
  ATHLETE: 'ATHLETE',
}

export const TRIGGER_BINARY_WINNER = {
  TEAM_A: 'TEAM_A',
  TEAM_B: 'TEAM_B',
  DRAW: 'DRAW',
}

export const TRIGGER_SUBCATEGORIES = {
  MATCH_RESULT: 'MATCH_RESULT',
  SCORE_RESULT: 'SCORE_RESULT',
}
